<template>
    <div class="d-flex flex-column gap-3">
        <CurrentAgency/>

        <div class="card card-body d-flex gap-3">
            <div class="d-flex justify-content-end">
                <ClearableInput v-model="searchQuery"
                                placeholder="Name, E-Mail, ..."
                                @input="value => search(value)"/>
            </div>

            <table class="table table-hover">
                <thead>
                <tr>
                    <th class="w-400px">
                        <TableSort field="name" :value="sort">
                            {{ __('general.user') }}
                        </TableSort>
                    </th>
                    <th>{{ __('user.contact_info') }}</th>
                    <th class="text-center">{{ __('general.agency') }}</th>
                    <th class="text-center">{{ __('general.stores') }}</th>
                    <th class="text-center">
                        <TableSort field="created_at" :value="sort">
                            {{ __('user.registration_date') }}
                        </TableSort>
                    </th>
                    <th class="text-right">{{ __('general.actions') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="user in paginatedUsers.data" :key="user.id">
                    <td>
                        <UserLink :user="user" show-avatar show-email/>
                    </td>
                    <td>
                        <a class="text-dark font-size-xl" :href="`tel:${user.phone}`">
                            <i class="fas fa-phone-square mr-2"/>
                            <span v-if="user.phone">{{ user.phone }}</span>
                            <span v-else>{{ __('general.not_available') }}</span>
                        </a>
                        <br>
                        <a class="text-black-50 font-size-sm" :href="`mailto:${user.email}`">
                            <i class="fas fa-envelope-square mr-2"/>
                            {{ user.email }}
                        </a>
                    </td>
                    <td class="text-center">
                        <Center vertical>
                            <span class="text-muted text-uppercase font-size-sm">{{ user.agency_name }}</span>
                        </Center>
                    </td>
                    <td>
                        <Center vertical>
                            <Center>
                                <span class="font-size-h4" :class="{'opacity-50': user.stores === 0}">
                                    {{ user.stores }}
                                </span>
                            </Center>
                        </Center>
                    </td>
                    <td class="text-center">
                        <Center vertical>
                            <div>{{ $localDate(user.created_at) }}</div>
                            <div class="text-muted font-size-sm">um {{ $localTime(user.created_at) }} Uhr</div>
                        </Center>
                    </td>
                    <TableActions>
                        <a v-if="Permission.EDIT_USERS" :href="$route('user.edit', [user.url_key])">
                            <TableAction>
                                <i class="fas fa-edit"/>
                            </TableAction>
                        </a>
                        <a v-if="Permission.MORPH_TO_USER" :href="$route('user.morph', {'user': user.url_key})">
                            <TableAction hover="btn-hover-light-info">
                                <i class="fas fa-sign-in-alt"/>
                            </TableAction>
                        </a>
                        <a v-if="Permission.DELETE_USERS" :href="$route('user.delete', {'user': user.url_key})">
                            <TableAction hover="btn-hover-light-danger">
                                <i class="fas fa-trash"/>
                            </TableAction>
                        </a>
                    </TableActions>
                </tr>
                </tbody>
            </table>

            <Pagination :pagination="paginatedUsers"
                        :inertia-options="{only: ['paginatedUsers']}"
            />
        </div>
    </div>
</template>

<script>
import CurrentAgency from '@components/Agency/CurrentAgency.vue';
import UserInitials from '@components/User/UserInitials.vue';
import TableAction from '@components/Table/TableAction.vue';
import TableActions from '@components/Table/TableActions.vue';
import Pagination from '@components/TableComponents/Pagination.vue';
import TableSort from '@components/Table/TableSort.vue';
import Center from '@components/Layout/Center.vue';
import ClearableInput from '@components/Form/ClearableInput.vue';
import {PermissionsMixin} from '@js/permissions';
import UserLink from "@components/User/UserLink.vue";

export default {
    components: {
        UserLink,
        UserInitials,
        CurrentAgency,
        TableAction,
        TableActions,
        Pagination,
        TableSort,
        Center,
        ClearableInput,
    },

    mixins: [
        PermissionsMixin,
    ],

    props: {
        paginatedUsers: Object,
    },

    data() {
        return {
            loading: false,
            filters: {},
            sort: {},
            searchQuery: '',
        };
    },

    methods: {
        reloadTableData(requestData = {}) {
            requestData.filters = this.filters;
            this.loading = true;

            this.$inertia.reload({
                data: requestData,
                only: ['paginatedUsers'],
                onSuccess: page => {
                    this.loading = false;
                },
                onError: page => {
                    this.loading = false;
                },
            });
        },

        search(query) {
            this.reloadTableData({
                search: query,
            });
        },
    },
};
</script>

<style>
.table td {
    vertical-align: middle;
}

.btn[disabled] {
    cursor: not-allowed;
}
</style>
